import {
  CONTEXT_LOAD,
  CONTEXT_LOAD_SUCCESS,
  CONTEXT_LOAD_FAIL,
  PROPERTIES_LOAD,
  PROPERTIES_LOAD_SUCCESS,
  PROPERTIES_LOAD_FAIL,
  MKT_SAVE,
  AUDIT_SAVE,
  PARTNER_CONFIG_LOAD_SUCCESS,
  BASEURL_SAVE,
} from './action-types';

const INITIAL_STATE = {
  context: {
    countryName: null,
    whatsappNumber: {
      number: null,
      display: null,
    },
    customerSupport: {
      number: null,
      display: null,
    },
    phone: {
      countryCode: null,
    },
    legalIdTypes: [],
    birthdate: {
      limits: {
        min: null,
        age: null,
      },
    },
    plate: {
      showNotPlateOption: true,
    },
    oneTrustId: null,
  },
  properties: {},
  mkt: {
    source: null,
    medium: null,
    gclid: null,
    referer: '',
    landingUrl: '',
  },
  audit: {},
  baseUrl: '',
  didContextLoad: false,
  checkout: {
    status: {
      isOk: false,
      isError: false,
      isLoading: true,
    },
  },
};

const mainReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONTEXT_LOAD:
      return {
        ...state,
      };
    case CONTEXT_LOAD_SUCCESS:
      return {
        ...state,
        context: action.payload,
        didContextLoad: true,
      };
    case CONTEXT_LOAD_FAIL:
      return {
        ...state,
        didContextLoad: true,
      };
    case PROPERTIES_LOAD:
      return {
        ...state,
      };
    case PROPERTIES_LOAD_SUCCESS:
      return {
        ...state,
        properties: action.payload,
      };
    case PROPERTIES_LOAD_FAIL:
      return {
        ...state,
      };
    case PARTNER_CONFIG_LOAD_SUCCESS:
      return {
        ...state,
        mkt: {
          ...state.mkt,
          source: action.payload.channel,
          medium: action.payload.campaign,
        },
      };
    case MKT_SAVE:
      return {
        ...state,
        mkt: action.payload,
      };
    case AUDIT_SAVE:
      return {
        ...state,
        audit: { ...state.audit, ...action.payload },
      };
    case BASEURL_SAVE:
      return {
        ...state,
        baseUrl: action.payload,
      };
    default:
      return state;
  }
};

export default mainReducer;
